import { heroImage, heroStats, siteMeta } from "@/mocks/home";

interface HeroProps {
  notify: (message: string) => void;
}

export default function Hero({ notify }: HeroProps) {
  return (
    <section id="top" className="relative overflow-hidden bg-background-50 pt-28 md:pt-36 pb-12 md:pb-16">
      <div className="absolute inset-0 grain opacity-60 pointer-events-none" />
      <div className="absolute -top-24 -right-24 w-[420px] h-[420px] rounded-full bg-primary-100/50 blur-3xl pointer-events-none" />
      <div className="absolute bottom-0 left-1/4 w-[320px] h-[320px] rounded-full bg-accent-100/40 blur-3xl pointer-events-none" />

      <div className="relative px-4 md:px-10 grid lg:grid-cols-12 gap-10 lg:gap-12 items-center">
        <div className="lg:col-span-7 animate-fade-up">
          <div className="inline-flex items-center gap-2 h-8 px-3 rounded-full bg-background-100 border border-background-200">
            <span className="w-2 h-2 rounded-full bg-primary-500 animate-pulse-dot" />
            <span className="text-xs text-foreground-700">
              {siteMeta.statusText} · 最后更新 {siteMeta.updatedAt}
            </span>
          </div>

          <h1 className="mt-6 font-heading text-4xl md:text-6xl font-black text-foreground-950 leading-tight text-balance">
            {siteMeta.name}
          </h1>
          <p className="mt-2 font-heading text-lg md:text-2xl text-primary-600 font-bold">
            最新更新维护 · 换地址新网址 · 一次找齐可用入口
          </p>

          <p className="mt-5 max-w-2xl text-sm md:text-base leading-relaxed text-foreground-600">
            {siteMeta.intro}
          </p>

          <div className="mt-7 flex flex-col sm:flex-row gap-3">
            <a
              href="#entries"
              className="inline-flex items-center justify-center gap-2 h-12 px-6 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-link-m" />
              查看最新可用入口
            </a>
            <button
              type="button"
              onClick={() => notify("社区板块在页面下方，向下滑动即可参与讨论")}
              className="inline-flex items-center justify-center gap-2 h-12 px-6 rounded-md bg-background-100 border border-background-200 text-foreground-800 text-sm font-medium hover:border-primary-300 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-chat-smile-2-line" />
              加入吃瓜社区
            </button>
          </div>

          <div className="mt-9 flex flex-wrap gap-x-10 gap-y-4">
            {heroStats.map((stat) => (
              <div key={stat.label} className="flex flex-col">
                <span className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
                  {stat.value}
                  <span className="ml-1 text-xs font-normal text-foreground-500">{stat.unit}</span>
                </span>
                <span className="text-xs text-foreground-500 mt-0.5">{stat.label}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="lg:col-span-5 animate-fade-in">
          <div className="relative w-full h-[240px] md:h-[380px] rounded-2xl overflow-hidden border border-background-200">
            <img
              src={heroImage}
              alt="黑料导航站点氛围插画"
              title="黑料导航 最新更新维护 换地址新网址"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/75 via-foreground-950/20 to-transparent" />
            <div className="absolute left-4 right-4 bottom-4">
              <p className="font-heading text-base md:text-lg font-bold text-background-50">
                吃瓜不迷路，从本页出发
              </p>
              <p className="mt-1 text-xs md:text-sm text-background-200 leading-relaxed">
                换地址、维护、线路调整，都会在这里第一时间同步。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}